export function hasPermission(
    permission: string,
    userPermissions: string[] = [],
    _debug: boolean = false,
): boolean {
    return userPermissions.includes(permission);
}
